// extracted by mini-css-extract-plugin
export default {"dayIcon":"day-icon_dayIcon__yrCfj","info":"day-icon_info__6Wkxt","warning":"day-icon_warning__MmWOb"};